var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title animate__animated animate__fadeInUp"},[_c('div',{staticClass:"txt"},[_vm._v(_vm._s(_vm.title))]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLine),expression:"showLine"}],class:{line: true, long: _vm.long, isCenter: _vm.isCenter}})])
}
var staticRenderFns = []

export { render, staticRenderFns }